/**
 * Potting labels are 4x2 at 300 DPI. Location is shared across potting pages.
 */

export { ZPL_PRINTER_STORAGE_KEYS } from "@/lib/zplPrinter";

import { ZPL_PRINTER_STORAGE_KEYS } from "@/lib/zplPrinter";
import { useZplPrintLocation } from "@/lib/zplPrintLocation";

export const POTTING_ZPL_PRINTER_STORAGE_KEY = ZPL_PRINTER_STORAGE_KEYS.potting;

export function usePottingZplPrinter(): ReturnType<typeof useZplPrintLocation> {
  return useZplPrintLocation({
    storageKey: POTTING_ZPL_PRINTER_STORAGE_KEY,
    labelSize: "4x2",
    dpi: 300,
  });
}
